import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEAnatomyTargetType as OEAnatomyTargetType_, OEAnatomyStartSelectionContent} from './oe-anatomy-consts';

export const OEAnatomyTargetType = OEAnatomyTargetType_;

export const OEAnatomyTargets = new OEVersionTargets(
    {
        [OEAnatomyTargetType.anatomy]: [
// @ADD_TARGET_ANATOMY_OETARGET
            OETarget.humanPatient,
            OETarget.humanBones,
            OETarget.humanArm,
            OETarget.humanShoulderGirdle,
            OETarget.humanUpperArmElbow,
            OETarget.humanForearm,
            OETarget.humanHand,
            OETarget.humanLeg,
            OETarget.humanHip2,
            OETarget.humanThighKnee,
            OETarget.humanLowerLeg,
            OETarget.humanAnkleFoot,
            OETarget.humanTrunk,
            OETarget.humanNeckBack,
            OETarget.humanChestWall,
            OETarget.humanAbdominalWall,
            OETarget.humanPelvis,
            OETarget.humanSpine,
            OETarget.humanSpineFracture2
        ],
        [OEAnatomyTargetType.head]: [
            OETarget.humanSkull,
            OETarget.humanHead,
            OETarget.humanHeadWIP,
            OETarget.humanCNS,
            OETarget.humanCNSWIP,
            OETarget.humanCranialNerves,
            OETarget.humanEye2,
            OETarget.humanEyeLid,
            OETarget.humanEyeCornea,
            OETarget.humanEarMacro,
            OETarget.humanEarInner,
            OETarget.humanEarMicro,
            OETarget.humanLarynx
        ],
        [OEAnatomyTargetType.organs]: [
            OETarget.humanRespiratoryEpithelium,
            OETarget.humanMuscleSpindle,
            OETarget.humanTrunkVessel,
            OETarget.humanBronchialTree,
            OETarget.humanRespiratorySystem,
            OETarget.humanGenitalMale,
        ],
        [OEAnatomyTargetType.biology]: [
            OETarget.humanCellEpithelium,
            OETarget.humanBrainSynapse,
            OETarget.humanSkinEpidermis,
            OETarget.humanSkin2,
            OETarget.virusSarscov2
        ]
    },
    {
        [OEAnatomyTargetType.anatomy]: OETarget.humanHip2,
        [OEAnatomyTargetType.head]: OETarget.humanSkull,
        [OEAnatomyTargetType.organs]: OETarget.humanTrunkVessel,
        [OEAnatomyTargetType.biology]: OETarget.humanCellEpithelium
    },
    {
        [OEAnatomyTargetType.anatomy]: OETarget.humanHand
    }
);

export const OEAnatomyFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
            headTargetSelection: !isLicensing,
            organsTargetSelection: !isLicensing,
            biologyTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
                featureAccess.headTargetSelection = true;
                featureAccess.organsTargetSelection = true;
                featureAccess.biologyTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEAnatomyTargets);

export const OEAnatomyStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEAnatomyTargets,
    OEAnatomyStartSelectionContent
);